import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	cancelButton: {
		id: 'admin-pages-priorities.common.modal-header.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Action button to exit the modal for adding or editing a priority',
	},
});
